
// select your monogram style
// interlock, bamboo, woven, greekkey

var monogrammer = {
    monograms: {
      interlock: {
        options: {
          'RR': 'double',
          'BL': 'double'
        }
      },
      woven: {
        options: {
          'A': 'double',
          'CH': 'double'
        }
      },
      bamboo: {
        options: {
          'LTD': 'block',
          'PMC': 'traditional',
          'D': 'single'
        }
      },
      greekkey: {
        options: {
          'NSO': 'block',
          'KSL': 'traditional',
          'E': 'single'
        }
      },
      motif: {
        options: {
          laurel: {
            mark: {
              x: 56,
              y: 43
            }
          },
          boxwood: {
          },
          crab: {
          },
          antler: {},
          crest: {},
          magnolia: {},
          oyster: {},
          anchor: {},
          lobster: {},
          equestrian: {},
          rooster: {},
          heron: {},
          bluebonnet: {},
          winecountry: {},
          longhorn: {},
          pineapple: {},
          celtic: {},
          elephant: {},
          tennis: {},
          cheetah: {},
          giraffe: {},
          zebra: {},
          bee: {},
          gingerjar: {},
          lemon: {},
          monkey: {},
          olympia: {},
          pine: {},
          sunburst: {},
          tassel: {},
          coral: {},
          flamingo: {},
          greekkeysquare: {
            font: 'copperplate'
          },
          greekkeyround: {
            font: 'copperplate'
          },
          pagoda: {},
          palm: {},
          flamingobambooframe: {},
          bambooframe: {},
          greekkeyframe: {},
          quail: {},
          golf: {},
          holidayantler: {},
          holidaybow: {},
          holidaycandycane: {},
          holidaygingerjar: {},
          holidayholly: {},
          holidaynutcracker: {},
          holidayoyster: {},
          holidaypalm: {},
          holidayreindeer: {},
          holidaytree: {},
          holidaythanksgiving: {},
          holidayhollysanta: {},
          holidaywreath: {}
        }
      },
      
  
      
  
    },
    $: function(target){
      // jQuery esque helper
      // if '.className' comes in search by class name else assume it is an id
      if (_.startsWith(target, '.')) return document.getElementsByClassName(target.replace('.', ''));
      else return document.getElementById(target.replace('#', ''))
  
    },
    preview: function(spritesheet, monogram, value){
      var renderData = {spritesheet: spritesheet, monogram: monogram, value: value, templates: this.templates};
      if(renderData !== this.selection){
        this.selection = renderData;
        this.options.previewEl.innerHTML = this.templates.largePreview(renderData);
        this.selectThumb();
      }
    },
    selectThumb: function(){
      var previousSelection = this.$('.selected');
      if (!_.isEmpty(previousSelection)) previousSelection[0].setAttribute('class', previousSelection[0].getAttribute('class').replace('selected'));
      var newSelection = document.getElementsByClassName(this.selection);
      // debugger;
      newSelection[0].setAttribute('class', newSelection[0].getAttribute('class') + ' selected');
    },
    init: function(options){
      this.options = _.defaults(options, {
        preview: '#preview',
        thumbnails: '#thumbnails'
      });
      this.options.previewEl = this.$(this.options.preview) || document.createElement('div');
      this.options.previewEl.setAttribute('id', this.options.preview);
      this.options.thumbnailsEl = this.$(this.options.thumbnails) || document.createElement('div');
      this.options.thumbnailsEl.setAttribute('id', this.options.thumbnails);
      
      this.templates = {
        basicPreview: _.template(this.$('template-basicPreview').innerHTML),
        blockOrTraditionalPreview: _.template(this.$('template-blockOrTraditionalPreview').innerHTML),
        largePreview: _.template(this.$('template-largePreview').innerHTML),
        thumbnails: _.template(this.$('template-thumbnails').innerHTML)
      };
      this.select = _.bindKey(monogrammer, 'preview');
      // render the thumbnails
      this.options.thumbnailsEl.innerHTML = this.templates.thumbnails(this);
      // attach click events to our thumbnails
      
    },
  
  
  };
  
  
  